import * as React from 'react';

import Rive from '@rive-app/react-canvas';

import {SelectPickerInlineText} from 'shells/select-picker-inline-text/select-picker-inline-text';
import type {SelectOption} from 'shells/select-picker-inline-text/select-picker-inline-text';

import {ANIMATION_SRC} from '../consts';

import {ChatOnboardingLayout} from './chat-onboarding-layout';

type Props = {
    domain: string;
    setDomain: (domain: string) => void;
    protocol: SelectOption;
    setProtocol: (protocol: SelectOption) => void;
    onSubmit: () => void;
    errorMessage: string | null | undefined;
    protocolOptions: Array<SelectOption>;
};

export function YourWebsite(props: Props) {
    return (
        <ChatOnboardingLayout
            title='Add a website'
            subtitle='Link your website to power your Engagement bar in under a minute—a smart tool for chatting, requesting information, or booking appointments.'
            animation={<Rive src={ANIMATION_SRC.YOUR_WEBSITE} />}
            errorMessage={props.errorMessage || undefined}
            actionComponent={
                <SelectPickerInlineText
                    selectOptions={props.protocolOptions}
                    selectedOption={props.protocol}
                    inlineText={props.domain}
                    onSelectChange={props.setProtocol}
                    onInlineTextChange={props.setDomain}
                    onSubmit={props.onSubmit}
                    selectDisabled={true}
                    focusOnMount={true}
                />
            }
        />
    );
}
